import {useMemo} from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import styles from "./Handbook.module.css";
import { HandbookShell } from "./_components/ui/HandbookShell/HandbookShell";
import { ROUTES } from "../../constants/routes";
import { HandbookTabs } from "./_components/ui/HandbookTabs/HandbookTabs";


import type { TabKey } from "./handbookAdd/types";

const TABS: Array<{ key: TabKey; label: string; path: string }> = [
    {
        key: "containerSites",
        label: "Контейнерные площадки",
        path: `/${ROUTES.HANDBOOK.path}/${ROUTES.HANDBOOK.CONTAINER_SITES}`,
    },
    {
        key: "containerSitesTypes",
        label: "Типы контейнерных площадок",
        path: `/${ROUTES.HANDBOOK.path}/${ROUTES.HANDBOOK.CONTAINER_SITES_TYPES}`,
    },
    {
        key: "vehicles",
        label: "Транспортные средства",
        path: `/${ROUTES.HANDBOOK.path}/${ROUTES.HANDBOOK.VEHICLES}`,
    },
    {
        key: "organizations",
        label: "Организации",
        path: `/${ROUTES.HANDBOOK.path}/${ROUTES.HANDBOOK.ORGANIZATIONS}`,
    },
    {
        key: "contractors",
        label: "Контрагенты",
        path: `/${ROUTES.HANDBOOK.path}/${ROUTES.HANDBOOK.CONTRACTORS}`,
    },

    {
        key: "geozones",
        label: "Геозоны",
        path: `/${ROUTES.HANDBOOK.path}/${ROUTES.HANDBOOK.GEOZONES}`,
    },
    {
        key: "containers",
        label: "Контейнеры",
        path: `/${ROUTES.HANDBOOK.path}/${ROUTES.HANDBOOK.CONTAINERS}`,
    },
    {
        key: "containerTypes",
        label: "Типы контейнеров",
        path: `/${ROUTES.HANDBOOK.path}/${ROUTES.HANDBOOK.CONTAINER_TYPES}`,
    },
    {
        key: "vehicleStatuses",
        label: "Статусы ТС",
        path: `/${ROUTES.HANDBOOK.path}/${ROUTES.HANDBOOK.VEHICLE_STATUSES}`,
    },
    {
        key: "loadTypes",
        label: "Типы загрузки",
        path: `/${ROUTES.HANDBOOK.path}/${ROUTES.HANDBOOK.LOAD_TYPES}`,
    },
    {
        key: "groupGeofence",
        label: "Группы геозон",
        path: `/${ROUTES.HANDBOOK.path}/${ROUTES.HANDBOOK.GROUP_GEOFENCE}`,
    },
    {
        key: "wasteTypes",
        label: "Типы отходов",
        path: `/${ROUTES.HANDBOOK.path}/${ROUTES.HANDBOOK.WASTE_TYPES}`,
    },
];

// определяем активный таб по URL
function getActiveTabKeyFromPath(pathname: string): TabKey {
    const best = [...TABS]
        .sort((a, b) => b.path.length - a.path.length)
        .find((t) => pathname === t.path || pathname.startsWith(t.path + "/") || pathname.startsWith(t.path));

    return best?.key ?? "containerSites";
}

export default function Handbook() {
    const navigate = useNavigate();
    const location = useLocation();


    const active = useMemo<TabKey>(() => getActiveTabKeyFromPath(location.pathname), [location.pathname]);

    const title = useMemo(() => {
        const found = TABS.find((t) => t.key === active);
        return found ? found.label : "Справочники";
    }, [active]);

    return (
        <div className={styles.page}>
            <div className={styles.panel}>
                <div>
                    <HandbookShell
                        title="Справочники"
                    >
                        <div className={styles.tabsRow}>
                            <HandbookTabs
                                tabs={TABS.map(({ key, label }) => ({ key, label }))}
                                active={active}
                                onChange={(k) => {
                                    const tab = TABS.find((t) => t.key === k);
                                    if (!tab) return;
                                    navigate(tab.path);
                                }}
                            />
                        </div>

                        <Outlet context={{title}}/>
                    </HandbookShell>

                </div>
            </div>
        </div>
    );
}
